<section id="content" class="p-3">
    <div class="row">
      <div class="col-md-12 col-xs-12 table-cont">
        <div class="form-group">
          <div class="card p-4">
            <div class="card-title mb-2">
              <h2>Order Item Details</h2>
            </div>
            <div class="cont">
              <div class="group">
                <form id="form">
                  <!-- Row 1 -->
                  <div class="row">
                    <!-- Column 1 -->
                    <div class="col-sm-4 mb-4">
                      <div class="form-group mb-3">
                        <label for="ship-to-party">Ship-To Party</label>
                        <input
                          type="text"
                          class="form-control"
                          id="ship-to-party"
                          name="shipToParty"
                          [(ngModel)]="stockItem.customerNumber"
                          readonly
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label for="delivery">Delivery</label>
                        <input
                          type="text"
                          class="form-control"
                          id="delivery"
                          name="delivery"
                          [(ngModel)]="stockItem.deliveryTicket.title"
                          readonly
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label for="serial-number">Serial Number</label>
                        <input 
                          type="text"
                          class="form-control"
                          id="serial-number"
                          name="serialNumber"
                          [(ngModel)]="orderItemDetails.serialNumber"
                          #serialNumber="ngModel"
                          required
                         >
                         <div *ngIf="serialNumber.invalid && serialNumber.touched" class="text-danger">
                            Serial Number is required.
                          </div>
                          
                      </div>
                      <div class="form-group mb-3">
                        <label for="Act. Gds Mvmnt Date">Act. Gds Mvmnt Date</label>
                        <p-calendar
                          id="ActGdsMvmntDate"
                          name="actGdsMvmntDate"
                          [showIcon]="true"
                          disabled="true" 

                          [showButtonBar]="true"
                          icon="pi pi-calendar"
                          placeholder="Act. Gds Mvmnt Date"
                          class="full-width"
                          dateFormat="yy-mm-dd"
                          [(ngModel)]="stockItem.deliveryTicket.deliveryDate"
                          readonly
                        ></p-calendar>
                      </div>
                      <div class="form-group mb-3">
                        <label for="sales-order-item">Sales Order</label>
                        <input
                          type="text"
                          class="form-control"
                          id="sales-order-item"
                          name="salesOrderItem"
                          [(ngModel)]="stockItem.salesOrderItemNumber"
                          readonly
                        />
                      </div>
                    </div>
  
                    <!-- Column 2 -->
                    <div class="col-sm-4 mb-4">
                      <div class="form-group mb-3">
                        <label for="name">Name</label>
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          name="customerName"
                          [(ngModel)]="stockItem.customerName" readonly
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label for="item">Item</label>
                        <input
                          type="text"
                          class="form-control"
                          id="item"
                          name="item"
                          [value]="stockItem.productCategory + ' - ' + stockItem.productType + ' - ' + stockItem.productItem"
                          readonly
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label for="delivery-qty">Delivery Qty</label>
                        <input
                          type="number"
                          class="form-control"
                          id="delivery-qty"
                          name="deliveryQty"
                          [(ngModel)]="stockItem.deliveryTicket.deliveredQty"
                          readonly
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label for="total-gds-mvmt-stat">Total Gds Mvmt Stat.</label>
                        <input
                          type="text"
                          class="form-control"
                          id="total-gds-mvmt-stat"
                          name="totalGdsMvmtStat"
                          [(ngModel)]="stockItem.deliveryTicket.movementState"
                          readonly
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label for="coverageFrom">Coverage From</label>
                        <p-calendar
                          id="coverageFrom"
                          name="coverageFrom"
                          [(ngModel)]="orderItemDetails.coverageFromDate"
                          dateFormat="yy-mm-dd"
                          [showIcon]="true"
                          [showButtonBar]="true"
                          icon="pi pi-calendar"
                          class="full-width"
                          #coverageFromDate="ngModel"
                          [disabled]="true"
                        ></p-calendar>
                        <div *ngIf="coverageFromDate.invalid && coverageFromDate.touched" class="text-danger">
                          coverage From is required.
                        </div>
                      </div>
                    </div>
  
                    <!-- Column 3 -->
                    <div class="col-sm-4 mb-4">
                      <div class="form-group mb-3">
                        <label for="master-contract-no">Master Contract No</label>
                        <input
                          type="text"
                          class="form-control"
                          id="master-contract-no"
                          name="masterContractNo"
                          [(ngModel)]="stockItem.orderNumber"
                          readonly
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label for="material">Material</label>
                        <input
                          type="text"
                          class="form-control"
                          id="material"
                          name="material"
                          [(ngModel)]="stockItem.partNumber"
                          readonly
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label for="Ticket Created On">Ticket Created On</label>
                        <p-calendar
                          id="createdOn"
                          name="createdOn"
                          [showIcon]="true"
                          [showButtonBar]="true"
                          icon="pi pi-calendar"
                          placeholder="Created On"
                          class="full-width"
                          dateFormat="yy-mm-dd"
                          [(ngModel)]="stockItem.deliveryTicket.createdDate"
                          disabled="true" 

                        ></p-calendar>
                      </div>
                      <div class="form-group mb-3">
                        <label for="sales-order">Sales Order Item</label>
                        <input
                          type="text"
                          class="form-control"
                          id="sales-order"
                          name="salesOrder"
                          [(ngModel)]="stockItem.salesOrderNumber"
                          readonly
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label for="coverageTo">Coverage To</label>
                        <p-calendar
                          id="coverageTo"
                          name="coverageTo"
                          [(ngModel)]="orderItemDetails.coverageToDate"
                          dateFormat="yy-mm-dd"
                          [showIcon]="true"
                          [showButtonBar]="true"
                          icon="pi pi-calendar"
                          class="full-width"
                          #coverageToDate="ngModel"
                          [disabled]="true"
                        ></p-calendar>
                        <div *ngIf="coverageToDate.invalid && coverageToDate.touched" class="text-danger">
                          coverage To is required.
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <!-- Row 2 (Text Areas) -->
                  <div class="row">
                    <div class="col-sm-6 mb-3">
                      <div class="form-group">
                        <label for="delivery-text">Delivery Text</label>
                        <textarea
                          class="form-control"
                          id="delivery-text"
                          name="deliveryText"
                          [(ngModel)]="stockItem.deliveryTicket.deliveryText"
                          readonly
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-sm-6 mb-3">
                      <div class="form-group">
                        <label for="material-description">Material Description</label>
                        <textarea
                          class="form-control"
                          id="material-description"
                          name="materialDescription"
                            [(ngModel)]="orderItemDetails.materialDescription"
                        ></textarea>
                      </div>
                    </div>
                  </div>
  
                  <!-- Footer -->
                  <div class="footer mt-3">
                    <button class="p-button-text" type="button" pButton label="Back" icon="pi pi-arrow-left" (click)="navigateToCustomerOrdersPage()"></button>
                    <p-toast></p-toast>
                    <button
                    type="button"
                    pButton
                    label="Save"
                    icon="pi pi-check"
                    (click)="saveChanges()"
                  ></button>
                  
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <p-toast></p-toast>